import { useEffect } from "react";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    if (selector.startsWith("link")) el.setAttribute("rel", "canonical");
    else el.setAttribute("name", "description");
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export const useSeo = (title, description, path) => {
  useEffect(() => {
    document.title = `${title} | A.C. ELEC 94`;
    if (description) setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", `https://acelec94.com${path}`);
  }, [title, description, path]);
};
